import React from 'react';
import './AvatarEyes.css';
import ClassicAvatar from './avatars/ClassicAvatar';
import DogAvatar from './avatars/DogAvatar';
import CatAvatar from './avatars/CatAvatar';
import MooseAvatar from './avatars/MooseAvatar';
import OwlAvatar from './avatars/OwlAvatar';

class AvatarEyes extends React.Component {
    render() {
        const { avatar, eyeAction, size, visualHint } = this.props;

        switch (avatar) {
            case 'dog':
                return <DogAvatar eyeAction={eyeAction} size={size} visualHint={visualHint} />;
            case 'cat':
                return <CatAvatar eyeAction={eyeAction} size={size} visualHint={visualHint} />;
            case 'moose':
                return <MooseAvatar eyeAction={eyeAction} size={size} visualHint={visualHint} />;
            case 'owl':
                return <OwlAvatar eyeAction={eyeAction} size={size} visualHint={visualHint} />;
            default:
                return <ClassicAvatar eyeAction={eyeAction} size={size} visualHint={visualHint} />;
        }
    }
}

export default AvatarEyes;
